export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/viewer/icon-reload-11a838c3381a52690cda5ab0b1537601.svg";